module.exports = __webpack_public_path__ + "img/3-9-endzone.92422254.jpg";